module.exports = __webpack_public_path__ + "static/media/lisa-portrait.02a64519.png";